import { render, staticRenderFns } from "./aStaffCommunityList.vue?vue&type=template&id=dae25e96&scoped=true"
import script from "./aStaffCommunityList.vue?vue&type=script&lang=js"
export * from "./aStaffCommunityList.vue?vue&type=script&lang=js"
import style0 from "./aStaffCommunityList.vue?vue&type=style&index=0&id=dae25e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae25e96",
  null
  
)

export default component.exports